import { isFunction } from 'lodash';
import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import {
  ADD_ORDER,
  CANCEL_ALL_ORDER,
  CANCEL_ORDER,
  FETCH_ALL_ORDER,
  FETCH_OPEN_ORDER,
  FETCH_OPEN_ORDERS_PAGINATE,
  FETCH_ORDER,
  FETCH_ORDER_PAGINATE,
  FETCH_ORDERS,
} from '../actions/order/action_types';

import actions from '../actions/order';
import rf from '../../requests/RequestFactory';
import consts from '../../consts';
import utils from '../../common/utils';

// saga effect

function* addOrder(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderRequest').createOrder(params), action.params.data);
    yield put(actions.addOrderActionSucceed(data));
    // yield put(orderBookActions.fetchAllOrderBookAction({
    //   coin: action.params.data.coin,
    //   currency: action.params.data.currency,
    // }));
    // yield put(actions.fetchOpenOrderAction({ pos: 0, count: consts.DEFAULT_PAGE_SIZE_OPEN_ORDER }));
    // yield put(userActions.fetchUserBalancesAction());
    yield utils.showNotification(window.$t('common.notification'), window.$t('Add order succeeded'));
  } catch (err) {
    // console.error(err);
    // console.log(err.message, "@: err.message");
    // yield utils.showNotification("Notification", "Add order failed", consts.TYPE_ERROR);
    yield put(actions.addOrderActionFailed(err));
  } finally {
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  }
}

function* fetchOrder(action) {
  try {
    const configApi = yield call((params) => rf.getRequest('OrderRequest').fetchSingle(params), action.params.data);
    yield put(actions.fetchOrderActionSucceed(configApi));
  } catch (err) {
    console.error(err);
    yield put(actions.fetchOrderActionFailed(err));
  }
}

function* fetchOpenOrder(action) {
  try {
    const { data, total_count } = yield call((params) => rf.getRequest('OrderRequest').fetchOpenOrders(params), action.params.data);
    yield put(actions.fetchOpenOrderActionSucceed(data, total_count));
    if (isFunction(action.callback)) {
      yield action.callback(total_count);
    }
  } catch (err) {
    console.error(err);
    yield put(actions.fetchOpenOrderActionFailed(err));
  }
}

function* fetchOrderPaginate(action) {
  try {
    const configApi = yield call((params) => rf.getRequest('OrderRequest').fetchOrderPaginate(params), action.params.data);
    yield put(actions.fetchOrderPaginateActionSucceed(configApi));
    if (action.callback) {
      yield action.callback(configApi.total_count);
    }
  } catch (err) {
    console.error(err);
    yield put(actions.fetchOrderPaginateActionFailed(err));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  }
}

function* fetchOpenOrderPaginate(action) {
  try {
    const configApi = yield call((params) => rf.getRequest('OrderRequest').fetchOpenOrderPaginate(params), action.params.data);
    yield put(actions.fetchOpenOrdersPaginateActionSucceed(configApi));
    if (action.callback) {
      yield action.callback(configApi.total_count);
    }
  } catch (err) {
    console.error(err);
    yield put(actions.fetchOpenOrdersPaginateActionFailed(err));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  }
}

function sleep(ms) {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

function* cancelOrder(action) {
  try {
    yield call((params) => rf.getRequest('OrderRequest').cancelOrder(params), action.params.data);
    // const configApi = yield call((params) => rf.getRequest('OrderRequest').cancelOrder(params), action.params.data);
    // yield put(actions.cancelOrderActionSucceed(configApi));
    if (!action.isExchange) {
      yield put(actions.fetchOpenOrderAction({
        pos: 0,
        count: action.pageSize,
      }));
    }

    // yield put(userActions.fetchUserBalancesAction());
    // }));
    yield utils.showNotification(window.$t('common.notification'), window.$t('model.cancel_order_success'));
  } catch (err) {
    console.error(err);
    yield put(actions.cancelOrderActionFailed(err));
    yield utils.showNotification(window.$t('common.notification'), window.$t('Cancel order failed'), consts.TYPE_ERROR);
  } finally {
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  }
}

function* cancelAllOrder(action) {
  try {
    yield call(() => rf.getRequest('OrderRequest').cancelAllOrder());
    yield put(actions.fetchOpenOrderActionSucceed([], 0));

    // yield put(userActions.fetchUserBalancesAction());
    // }));
    yield utils.showNotification(window.$t('common.notification'), window.$t('model.cancel_order_success'));
  } catch (err) {
    console.error(err);
    yield put(actions.cancelOrderActionFailed(err));
    yield utils.showNotification(window.$t('common.notification'), window.$t('Cancel order failed'), consts.TYPE_ERROR);
  } finally {
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  }
}

function* fetchAllOrder(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('OrderRequest').fetchAllOrders(params), action.params.data);
    yield put(actions.fetchAllOrderActionSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    yield put(actions.fetchAllOrderActionFailed(err));
  }
}

function* fetchOrders(action) {
  try {
    const { data, total_count } = yield call((params) => rf.getRequest('OrderRequest').fetchOrders(params), action.params.data);
    yield put(actions.fetchAllOrderActionSucceed(data));
    if (isFunction(action.callback)) {
      yield action.callback(total_count);
    }
  } catch (err) {
    yield put(actions.fetchAllOrderActionFailed(err));
  }
}

function* watchAllOrders() {
  yield takeLatest(ADD_ORDER, addOrder);
  yield takeLatest(FETCH_ORDER, fetchOrder);
  yield takeLatest(FETCH_ALL_ORDER, fetchAllOrder);
  yield takeLatest(FETCH_OPEN_ORDER, fetchOpenOrder);
  yield takeLatest(FETCH_ORDERS, fetchOrders);
  yield takeLatest(FETCH_OPEN_ORDERS_PAGINATE, fetchOpenOrderPaginate);
  yield takeLatest(FETCH_ORDER_PAGINATE, fetchOrderPaginate);
  yield takeLatest(CANCEL_ORDER, cancelOrder);
  yield takeLatest(CANCEL_ALL_ORDER, cancelAllOrder);
}

export default function* rootSaga() {
  yield all([fork(watchAllOrders)]);
}
